/**
 * Create an application module for our calcApp
 * and control the root for the application..
 */
angular.module('calcApp', []).controller('mainCtrl', [ '$scope',

	function ( $scope ) {

		$scope.calc = function() {

			var points = 0;
			var count = 0;

			angular.forEach( $scope.age, function ( val, key ) {

				if ( val ) {
					count++;
				} else if ( val ) {
					count--;
				}

				// check if not false
				if ( val ) {

					if ( val >= 0 && val <= 5 ) {
						points += 4;
					} else if ( val >= 6 && val <= 12 ) {
						points += 2;
					} else if ( val >= 13 && val <= 17 )  {
						points += 0;
					}

					// return value as points scope
					return $scope.points = points;

				}

			});

			/**
			 * Count field
			 * @type {number}
			 */
			$scope.count = count;

		};


	}

] );